import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// import HomeView from '../views/HomeView.vue'
import pyyy from "@/components/python/index.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "html",
    component: () => import("../components/Html-w.vue"),
    children: [
      // 聊天机器人
      {
        path: "homtChat",
        component: () => import("../components/homtChat.vue"),
      },
      //历史记录
      {
        path: "HistoricalRecord",
        component: () => import("../components/HistoricalRecord.vue"),
      },
      //首页
      {
        path: "homeTools",
        component: () => import("../components/homtTools.vue"),
      },
      //个人页面
      {
        path: "user",
        component: () => import("../components/user_1.vue"),
      },
      //ai
      {
        path: "Patrick",
        component: () => import("../components/A_1.vue"),
      },
      //配音
      {
        path: "OralDubbing",
        component: () => import("../components/OralDubbing/index.vue"),
      },
      //批改作业
      {
        path: "homework",
        component: () => import("../components/correcting/homework.vue"),
      },
      //魔法配图
      {
        path: "Magic",
        component: () => import("../components/picture/Magic.vue"),
      },
      //魔法图片主页
      {
        path: "gszy",
        component: () => import("../components/gszy_1.vue"),
      },
      //卡通合影
      {
        path: "fwtzz",
        component: () => import("../components/fwtzz/Magic.vue"),
      },
      //魔法帖纸
      {
        path: "Stickers",
        component: () => import("../components/Stickers/Magic.vue"),
      },
      //发音评估
      {
        path: "Speech",
        component: () => import("@/components/Speech/Speech0ne.vue"),
      },
      //发音分类评估
      {
        path: "Pronunciation",
        component: () => import("@/components/Speech/index.vue"),
      },
      //支付
      {
        path: "Payment",
        component: () =>
          import("../components/subAccountManagement/Payment.vue"),
      },
      //订单
      {
        path: "Subscription",
        component: () => import("../components/Sub/Subscription.vue"),
      },
      //订单详情
      {
        path: "details",
        component: () => import("../components/Sub/details.vue"),
      },
      //订单结果
      {
        path: "Result",
        component: () => import("../components/Sub/Result.vue"),
      },
      // //分享中心
      // {
      //   path:'sharing',
      //   component:()=>import('../components/Link/sharing.vue')
      // },
      //分享链接
      {
        path: "Sharelink",
        component: () => import("../components/Link/index.vue"),
      },
      //订单列表
      {
        path: "OrderList",
        component: () => import("../components/Sub/OrderList.vue"),
      },
      //词汇表
      {
        path: "WordList",
        component: () => import("../components/WordList/Text.vue"),
      },
      //词汇表
      {
        path: "ExportingWords",
        component: () => import("../components/WordList/index.vue"),
      },
      //文本词汇表
      {
        path: "Text",
        component: () => import("../components/WordList/Text.vue"),
      },
      //短语配音
      {
        path: "dubbing",
        component: () =>
          import("../components/OralDubbing/dubbing/dubbing.vue"),
      },

      //单词配音
      {
        path: "OralDubbingdd",
        component: () => import("../components/OralDubbing/OralDubbing.vue"),
      },
      //自定义
      {
        path: "custom",
        component: () => import("../components/OralDubbing/custom.vue"),
      },
      //聊天机器人
      {
        path: "chat",
        component: () => import("@/components/chat/index.vue"),
      },
      //娟妮老师
      {
        path: "chatjuanni",
        component: () => import("@/components/chat/chatjuanni.vue"),
      },
      // 英语规划师
      {
          path: "chatPlanner",
        component: () => import("@/components/chat/chatPlanner.vue"),
      },
      // 成交力导师
      {
          path: "bargain",
        component: () => import("@/components/chat/bargain.vue"),
      },
      // 绘本阅读教育初级
      {
          path: "primaryReading",
        component: () => import("@/components/chat/primaryReading.vue"),
      },
      // 绘本阅读教育高级
      {
          path: "advancedReading",
        component: () => import("@/components/chat/advancedReading.vue"),
      },
      // 自然拼读初阶
      {
          path: "Phonics",
        component: () => import("@/components/chat/Phonics.vue"),
      },
      //资源导航
      {
        path: "Navigation",
        component: () => import("@/components/zy/index.vue"),
      },
      //文件上传
      {
        path: "UploadFiles",
        component: () => import("@/components/UploadFiles/Uploadfiles.vue"),
      },
      //作业批改主页
      {
        path: "petcorrectin",
        component: () => import("@/components/petcorrectin/home.vue"),
      },
      //pet作文批改electronic
      {
        path: "pettask",
        component: () => import("@/components/petcorrectin/homework.vue"),
      },
      //电子文档归纳总结
      {
        path: "electronic",
        component: () => import("@/components/electronic/Uploadfiles.vue"),
      },
      //电子文档归纳总结
      {
        path: "Wordrecitation",
        component: () => import("@/components/Wordrecitation/index.vue"),
      },
      //ppt生成器
      {
        path: "pptcs",
        component: () => import("@/components/pptcs/index.vue"),
      },
      //教程
      {
        path: "video",
        component: () => import("@/components/video/index.vue"),
      },
      //教程
      {
        path: "linking",
        component: () => import("@/components/OralDubbing/linking/index.vue"),
      },
      //教程
      {
        path: "musicians",
        component: () => import("@/components/musicians/musicians.vue"),
      },

      //教程
      {
        path: "lasiodn",
        component: () => import("@/components/OralDubbing/lasiodn/index.vue"),
      },

      //教程
      {
        path: "thkak",
        component: () => import("@/components/thkak/index.vue"),
      },

      //教程
      {
        path: "flashcard",
        component: () => import("@/components/flashcard/index.vue"),
      },

      //教程
      {
        path: "PictureBooks",
        component: () => import("@/components/PictureBooks/PictureBooks.vue"),
      },
      //教程
      {
        path: "language",
        component: () => import("@/components/language/index.vue"),
      },

      //教程
      {
        path: "languageddd",
        component: () => import("@/components/language/language.vue"),
      },

      //教程
      {
        path: "Management",
        component: () => import("@/components/Management/index.vue"),
      },
      //教程
      {
        path: "aisijib",
        component: () => import("@/components/aisijib/index.vue"),
      },
      //教程
      {
        path: "Homeworkpaper",
        component: () => import("@/components/Homeworkpaper/index.vue"),
      },
      {
        path: "WeChat",
        component: () => import("@/components/WeChat/index.vue"),
      },
      // {

      //   path: "wechatwechat",
      //   component: () => import("@/components/WeChat/wechat.vue"),
      // },
      {
        path: "wechatwechat",
        component: () => import("@/components/videos/index.vue"),
      },
      {
        path: "videos",
        component: () => import("@/components/videos/videos.vue"),
      },
      {
        path: "fcecorrectin",
        component: () => import("@/components/fcecorrectin/homework.vue"),
      },
      {
        path: "Sdc",
        component: () => import("@/components/Sdc/Magic.vue"),
      },
      {
        path: "download",
        component: () => import("@/components/xz/index.vue"),
      },
      {
        path: "/work_2",
        name: "work_2",
        component: () => import("@/components/work_2.vue"),
      },
      {
        path: "/WordCards",
        name: "WordCards",
        component: () => import("@/components/WordCards/index.vue"),
      },
      {
        path: "/Findwords",
        name: "Findwords",
        component: () => import("@/components/Findwords/index.vue"),
      },

      {
        path: "/cutee",
        name: "cutee",
        component: () => import("@/components/cutee/Magic.vue"),
      },

      {
        path: "/lessonPreparation",
        name: "lessonPreparation",
        component: () => import("@/components/lessonPreparation/homework.vue"),
      },
      {
        path: "/wordIllustrations",
        name: "wordIllustrations",
        component: () => import("@/components/wordIllustrations/index.vue"),
      },
      {
        path: "/subAccountManagement",
        name: "subAccountManagement",
        component: () =>
          import("@/components/subAccountManagement/Payment.vue"),
      },
      {
        path: "/xzmusic",
        name: "xzmusic",
        component: () => import("@/components/xz/music.vue"),
      },
      {
        path: "/Pictureasignmentpaper",
        name: "Pictureasignmentpaper",
        component: () => import("@/components/Pictureasignmentpaper/index.vue"),
      },
      {
        path: "/luanXuZuoYeZhi",
        name: "luanXuZuoYeZhi",
        component: () =>
          import("@/components/Pictureasignmentpaper/luanXuZuoYeZhi.vue"),
      },
      {
        path: "/lxianxizhi",
        name: "lxianxizhi",
        component: () =>
          import("@/components/Pictureasignmentpaper/lxianxizhi.vue"),
      },

      {
        path: "/PDFConversion",
        name: "PDFConversion",
        component: () => import("@/components/PDFConversion/index.vue"),
      },

      {
        path: "/cartoonLetterDisorder",
        name: "cartoonLetterDisorder",
        component: () =>
          import(
            "@/components/Pictureasignmentpaper/cartoonLetterDisorder.vue"
          ),
      },
      {
        path: "/cartoonWordConnection",
        name: "cartoonWordConnection",
        component: () =>
          import(
            "@/components/Pictureasignmentpaper/cartoonWordConnection.vue"
          ),
      },
      {
        path: "/themeVocabularyCard",
        name: "themeVocabularyCard",
        component: () =>
          import("@/components/Pictureasignmentpaper/themeVocabularyCard.vue"),
      },
      {
        path: "/bigFlashCard",
        name: "bigFlashCard",
        component: () =>
          import("@/components/Pictureasignmentpaper/bigFlashCard.vue"),
      },
      {
        path: "/bigFlashCardxby",
        name: "bigFlashCardxby",
        component: () =>
          import("@/components/Pictureasignmentpaper/bigFlashCardxby.vue"),
      },
      {
        path: "/dasdasd",
        name: "dasdasd",
        component: () =>
          import("@/components/Pictureasignmentpaper/dasdasd.vue"),
      },
      {
    path: "/TopicEntry",
    name: "TopicEntry",
    component: () => import("@/components/TopicEntry/TopicEntry.vue"),
  },
      {
        path: "/assignHomework",
        name: "assignHomework",
        component: () => import("@/components/assignHomework/index.vue"),
      },
      {
        path: "/fillInTheBlanksWithLetters",
        name: "fillInTheBlanksWithLetters",
        component: () =>
          import(
            "@/components/Pictureasignmentpaper/fillInTheBlanksWithLetters.vue"
          ),
      },
      {
        path: "/wordMemoryCard",
        name: "wordMemoryCard",
        component: () => import("@/components/wordMemoryCard/index.vue"),
      },
      {
        path: "/wordMemoryCardindex",
        name: "wordMemoryCardindex",
        component: () =>
          import("@/components/wordMemoryCard/wordMemoryCard.vue"),
      },
      {
        path: "/customPictureBook",
        name: "customPictureBook",
        component: () =>
          import("@/components/customPictureBook/customPictureBook.vue"),
      },
      {
        path: "/wordDictation",
        name: "wordDictation",
        component: () => import("@/components/wordDictation/index.vue"),
      },
      {
        path: "/wordDictationwordDictation",
        name: "wordDictationwordDictation",
        component: () => import("@/components/wordDictation/wordDictation.vue"),
      },
      {
        path: "/cartoonVocabularyList",
        name: "cartoonVocabularyList",
        component: () => import("@/components/cartoonVocabularyList/index.vue"),
      },
      {
        path: "/cartoonVocabularyListCartoonVocabularyList",
        name: "cartoonVocabularyListCartoonVocabularyList",
        component: () =>
          import("@/components/cartoonVocabularyList/wordDictation.vue"),
      },
      {
        path: "/cartoonVocabularyListCartoonxbybbmobdn",
        name: "cartoonVocabularyListCartoonxbybbmobdn",
        component: () =>
          import("@/components/cartoonVocabularyList/xbybbmobdn.vue"),
      },
      {
        path: "/wordClassificationCleaning",
        name: "wordClassificationCleaning",
        component: () =>
          import(
            "@/components/wordClassificationCleaning/wordClassificationCleaning.vue"
          ),
      },
      {
        path: "/wordSplittingCard",
        name: "wordSplittingCard",
        component: () => import("@/components/wordSplittingCard/index.vue"),
      },
      {
        path: "/wordSplittingCardwordSplittingCard",
        name: "wordSplittingCardwordSplittingCard",
        component: () =>
          import("@/components/wordSplittingCard/wordSplittingCard.vue"),
      },
      {
        path: "/sentenceDisassemblyCard",
        name: "sentenceDisassemblyCard",
        component: () =>
          import("@/components/sentenceDisassemblyCard/index.vue"),
      },
      {
        path: "/phraseExpansion",
        name: "phraseExpansion",
        component: () => import("@/components/phraseExpansion/index.vue"),
      },
      {
        path: "/phraseExpansion1",
        name: "phraseExpansion1",
        component: () => import("@/components/phraseExpansion/index1.vue"),
      },
       {
        path: "/phraseExpansion2",
        name: "phraseExpansion2",
        component: () => import("@/components/phraseExpansion/index2.vue"),
      },
      {
        path: "/phraseExpansion4",
        name: "phraseExpansion4",
        component: () => import("@/components/phraseExpansion/index4.vue"),
      },
      {
        path: "/naturalPhonics",
        name: "naturalPhonics",
        component: () => import("@/components/naturalPhonics/naturalPhonics.vue"),
      },
       {
        path: "/EssayScaffolding",
        name: "EssayScaffolding",
        component: () => import("@/components/EssayScaffolding/index.vue"),
      },
      {
        path: "/readThePicture",
        name: "readThePicture",
        component: () => import("@/components/readThePicture/index.vue"),
      },
      {
        path: "/SuperSentenceMaker",
        name: "SuperSentenceMaker",
        component: () => import("@/components/SuperSentenceMaker/index.vue"),
      },
      {
        path: "/phraseExpansion3",
        name: "phraseExpansion3",
        component: () => import("@/components/phraseExpansion/index3.vue"),
      },
       {
        path: "/phraseExpansion5",
        name: "phraseExpansion5",
        component: () => import("@/components/phraseExpansion/index5.vue"),
      },
      {
        path: "/knowledgeList",
        name: "knowledgeList",
        component: () => import("@/components/knowledgeList/homework.vue"),
      },

      {
        path: "/phraseExpansionProblem",
        name: "phraseExpansionProblem",
        component: () =>
          import("@/components/phraseExpansionProblem/index.vue"),
      },
      {
        path: "/youXi",
        name: "youXi",
        component: () => import("@/components/youXi/index.vue"),
      },
      {
        path: "/phidcsl",
        name: "phidcsl",
        component: () => import("@/components/phraseExpansion/phidcsl.vue"),
      },
      {
        path: "/phidcsl1",
        name: "phidcsl1",
        component: () => import("@/components/phraseExpansion/phidcsl1.vue"),
      },
      {
        path: "/phidcsl2",
        name: "phidcsl2",
        component: () => import("@/components/phraseExpansion/phidcsl2.vue"),
      },
      {
        path: "/phidcsl3",
        name: "phidcsl3",
        component: () => import("@/components/phraseExpansion/phidcsl3.vue"),
      },
      {
        path: "/zaixsk",
        name: "zaixsk",
        component: () => import("@/components/flashcard/zaixsk/index.vue"),
      },
      {
        path: "/thinking",
        name: "thinking",
        component: () => import("@/components/thinking/index.vue"),
      },

      {
        path: "/thinking",
        name: "thinking",
        component: () => import("@/components/thinking/index.vue"),
      },
      {
        path: "/jksadka",
        name: "jksadka",
        component: () => import("@/components/thinking/jksadka.vue"),
      },
      {
        path: "/yyzyzindex",
        name: "yyzyzindex",
        component: () => import("@/components/yyzyz/index.vue"),
      },
      {
        path: "/yyzyzds",
        name: "yyzyzds",
        component: () => import("@/components/yyzyz/yyzyzds.vue"),
      },
      {
        path: "/Unit",
        name: "Unit",
        component: () => import("@/components/Unit/index.vue"),
      },
      {
        path: "/unitdd",
        name: "unitdd",
        component: () => import("@/components/Unit/unitdd.vue"),
      },
      {
        path: "/worksheetindex",
        name: "worksheetindex",
        component: () => import("@/components/worksheet/index.vue"),
      },
      {
        path: "/worksheetadmin",
        name: "worksheetadmin",
        component: () => import("@/components/worksheet/admin.vue"),
      },
      {
        path: "/multiPersonSynthesis",
        name: "multiPersonSynthesis",
        component: () => import("@/components/multiPersonSynthesis/index.vue"),
      },
      {
        path: "/zhonsyek",
        name: "zhonsyek",
        component: () => import("@/components/wordDictation/zhonsyek.vue"),
      },
      {
        path: "/feedback",
        name: "feedback",
        component: () => import("@/components/feedback/homework.vue"),
      },
      {
        path: "/buckle",
        name: "buckle",
        component: () => import("@/components/buckle/index.vue"),
      },
      {
        path: "/bucklejksadka",
        name: "bucklejksadka",
        component: () => import("@/components/buckle/jksadka.vue"),
      },
      {
        path: "/buckleldksaj",
        name: "buckleldksaj",
        component: () => import("@/components/buckle/ldksaj.vue"),
      },
      {
        path: "/bucklejksadk23",
        name: "bucklejksadk23",
        component: () => import("@/components/buckle/jksadk23.vue"),
      },
      {
        path: "/bucklejksadkqe",
        name: "bucklejksadkqe",
        component: () => import("@/components/buckle/jksadkqe.vue"),
      },
      {
        path: "/youXizaixsk",
        name: "youXizaixsk",
        component: () => import("@/components/youXi/zaixsk/index.vue"),
      },
      {
        path: "/earlyReadingindex",
        name: "earlyReadingindex",
        component: () => import("@/components/earlyReading/index.vue"),
      },
     
      {
        path: "/mixing",
        name: "mixing",
        component: () => import("@/components/OralDubbing/lasiodn/mixing.vue"),
      },

      {
        path: "/Conjunctions",
        name: "Conjunctions",
        component: () => import("@/components/Conjunctions/index.vue"),
      },
      {
        path: "/cartoonMindMapindex",
        name: "cartoonMindMapindex",
        component: () => import("@/components/cartoonMindMap/index.vue"),
      },
      {
        path: "/yyzyzAutoDraw",
        name: "yyzyzAutoDraw",
        component: () => import("@/components/yyzyz/AutoDraw.vue"),
      },
      {
        path: "/advancedReadingPracticeindex",
        name: "advancedReadingPracticeindex",
        component: () => import("@/components/advancedReadingPractice/index.vue"),
      },
      {
        path: "/spldajkindex",
        name: "spldajkindex",
        component: () => import("@/components/spldajk/index.vue"),
      },
      {
        path: "/VideoReading",
        name: "VideoReading",
        component: () => import("@/components/advancedReadingPractice/VideoReading.vue"),
      },
      {
        path: "/dasflllll",
        name: "dasflllll",
        component: () => import("@/components/dasflllll/index.vue"),
      },
      {
        path: "/bucklejksadkadasflllll",
        name: "bucklejksadkadasflllll",
        component: () => import("@/components/dasflllll/jksadka.vue"),
      },
      {
        path: "/jksadkadiandun",
        name: "jksadkadiandun",
        component: () => import("@/components/thinking/jksadkadiandun.vue"),
      },
      {
        path: "/dehfal",
        name: "dehfal",
        component: () => import("@/components/thinking/dehfal.vue"),
      },
      {
        path: "/iajsdal",
        name: "iajsdal",
        component: () => import("@/components/cartoonMindMap/iajsdal.vue"),
      },
      {
        path: "/SentencePracticeindex",
        name: "SentencePracticeindex",
        component: () => import("@/components/phraseExpansionProblem/SentencePractice/index.vue"),
      },
      // 新增句子朗读
      {
        path: "/PointReadingText",
        name: "PointReadingText",
        component: () => import("@/components/PointReadingText/PointReadingText.vue"),
      },
      // // 句子朗读详情页
      // {
      //   path: "/detailsSentenceReading",
      //   name: "detailsSentenceReading",
      //   component: () => import("@/components/detailsSentenceReading/detailsSentenceReading.vue"),
      // },
      {
        path: "/cartoonVocabularyListdasfff",
        name: "cartoonVocabularyListdasfff",
        component: () => import("@/components/cartoonVocabularyList/dasfff.vue"),
      },
      {
        path: "/fillintheblanks",
        name: "fillintheblanks",
        component: () => import("@/components/phraseExpansionProblem/fillintheblanks/index.vue"),
      },
       {
        path: "/safkdfb",
        name: "safkdfb",
        component: () => import("@/components/WordCards/safkdfb.vue"),
      },
       {
        path: "/fiveanwordsindex",
        name: "fiveanwordsindex",
        component: () => import("@/components/fiveanwords/index.vue"),
      },
       {
        path: "/fiveanwordsasfak",
        name: "fiveanwordsasfak",
        component: () => import("@/components/fiveanwords/asfak.vue"),
      },
       {
        path: "/NewCompnusyllable",
        name: "NewCompnusyllable",
        component: () => import("@/NewCompnu/syllable/index.vue"),
      },
       {
        path: "/XiaZaiYeMian",
        name: "XiaZaiYeMian",
        component: () => import("@/NewCompnu/syllable/XiaZaiYeMian.vue"),
      },
       {
        path: "/Enlightenmentindex",
        name: "Enlightenmentindex",
        component: () => import("@/NewCompnu/Enlightenment/index.vue"),
      },
       {
        path: "/NewCompnuEnlightenment",
        name: "NewCompnuEnlightenment",
        component: () => import("@/NewCompnu/Enlightenment/Enlightenment.vue"),
      },
       {
        path: "/wordLearningindex",
        name: "wordLearningindex",
        component: () => import("@/NewCompnu/wordLearning/index.vue"),
      },
       {
        path: "/shortEssayindex",
        name: "shortEssayindex",
        component: () => import("@/NewCompnu/shortEssay/index.vue"),
      },
      {
        path: "/shortEssayindex1",
        name: "shortEssayindex1",
        component: () => import("@/NewCompnu/shortEssay/index1.vue"),
      },
      {
        path: "/batchModification",
        name: "batchModification",
        component: () => import("@/components/batchModification/index.vue"),
      },
       {
        path: "/NewCompnuInterlinking",
        name: "NewCompnuInterlinking",
        component: () => import("@/NewCompnu/Interlinking/index.vue"),
      },
       {
        path: "/shortEssaydczzy",
        name: "shortEssaydczzy",
        component: () => import("@/NewCompnu/shortEssay/dczzy.vue"),
      },
      {
        path: "/EnglishComposition",
        name: "EnglishComposition",
        component: () => import("@/NewCompnu/EnglishComposition/index.vue"),
      },
      {
        path: "/dictationPractice",
        name: "dictationPractice",
        component: () => import("@/components/phraseExpansion/index6.vue"),
      },
      {
        path: "/ReadingPractice",
        name: "ReadingPractice",
        component: () => import("@/components/phraseExpansion/index7.vue"), 
      },
       {
        path: "/Uploadindex",
        name: "Uploadindex",
        component: () => import("@/NewCompnu/Upload/index.vue"),
      },
       {
        path: "/childrenindex",
        name: "childrenindex",
        component: () => import("@/NewCompnu/children/index.vue"),
      },
    
       {
        path: "/childrenchildren",
        name: "childrenchildren",
        component: () => import("@/NewCompnu/children/children.vue"),
      },
    
       {
        path: "/yudulijie",
        name: "yudulijie",
        component: () => import("@/NewCompnu/yudulijie/yudulijie.vue"),
      },
    
       {
        path: "/ktdcddz",
        name: "ktdcddz",
        component: () => import("@/NewCompnu/ktdcddz/index.vue"),
      },
    
       {
        path: "/ktdcddzunitdd",
        name: "ktdcddzunitdd",
        component: () => import("@/NewCompnu/ktdcddz/unitdd.vue"),
      },
       {
        path: "/NewCompnuzhujuan",
        name: "NewCompnuzhujuan",
        component: () => import("@/NewCompnu/zhujuan/index.vue"),
      },
       {
        path: "/vipyouxiindex",
        name: "vipyouxiindex",
        component: () => import("@/NewCompnu/vipyouxi/index.vue"),
      },
      {
        path: "/vipyouxiindex",
        name: "vipyouxiindex",
        component: () => import("@/NewCompnu/vipyouxi/index.vue"),
      },
      // 合伙人专区
      {
        path: "/partnerArea",
        name: "partnerArea",
        component: () => import("../components/partnerArea/index.vue"),
      },
       // 舒尔特练习纸
      {
        path: "/wordHomeWorkBox",
        name: "wordHomeWorkBox",
        component: () => import("../components/wordHomeWorkBox/index.vue"),
      },
      // 字母舒尔特练习纸创建
      {
        path: "/addletterHomeWork",
        name: "addletterHomeWork",
        component: () => import("../components/wordHomeWork/addletterHomeWork.vue"),
      },
      // 字母舒尔特练习纸预览下载
      {
        path: "/letterHomeWorkIndex",
        name: "letterHomeWorkIndex",
        component: () => import("../components/wordHomeWork/letterHomeWorkIndex.vue"),
      },
      // 自拼舒尔特练习纸创建
      {
        path: "/addWordHomeWork",
        name: "addWordHomeWork",
        component: () => import("../components/wordHomeWork/addWordHomeWork.vue"),
      },
       // 自拼舒尔特练习纸预览下载
      {
        path: "/wordHomeWorkIndex",
        name: "wordHomeWorkIndex",
        component: () => import("../components/wordHomeWork/wordHomeWorkIndex.vue"),
      },
      // 防盗版工具
      {
        path: "/invisibleWatermark",
        name: "invisibleWatermark",
        component: () => import("../components/invisibleWatermark/index.vue"),
      },
      // 测试my ip
      {
         path: "/myIp",
        name: "myIp",
        component: () => import("../NewCompnu/myIp/newMyIp.vue"),
      },
      // 生成my ip
      {
         path: "/generate",
        name: "generate",
        component: () => import("../NewCompnu/myIp/generate.vue"),
      },
      // 生成my ip结果
      {
         path: "/myIpResult",
        name: "myIpResult",
        component: () => import("../NewCompnu/myIp/result.vue"),
      },
       // 语篇填空专项训练
      {
         path: "/textFillInTheBlank",
        name: "textFillInTheBlank",
        component: () => import("../NewCompnu/textFillInTheBlank/index.vue"),
      }
    ],
  },

  {
    path: "/ConjunctiSentencePractice",
    name: "ConjunctiSentencePractice",
    component: () => import("@/components/phraseExpansionProblem/SentencePractice/SentencePractice.vue"),
  },
  {
    path: "/fillintheblanfillintheblanksks",
    name: "fillintheblanfillintheblanksks",
    component: () => import("@/components/phraseExpansionProblem/fillintheblanks/fillintheblanks.vue"),
  },
  {
    path: "/Conjunctionssentences",
    name: "Conjunctionssentences",
    component: () => import("@/components/Conjunctions/sentences.vue"),
  },
  {
    path: "/dasfllllldsfjsff",
    name: "dasfllllldsfjsff",
    component: () => import("@/components/dasflllll/dsfjsff.vue"),
  },

  {
    path: "/FindwordsFindwords",
    name: "FindwordsFindwords",
    component: () => import("@/components/Findwords/Findwords.vue"),
  },
  {
    path: "/feedbackListindex",
    name: "feedbackListindex",
    component: () => import("@/components/feedback/index.vue"),
  },   
  {
        path: "/youXizsixiang",
        name: "youXizsixiang",
        component: () => import("@/components/youXi/zaixsk/zsixiang.vue"),
      },
  // 聊天机器人
  {
    path: "/homtChat",
    name: "homtChat",
    component: () => import("../components/homtChat.vue"),
  },
  {
    path: "/earlyReadingzsixiang",
    name: "earlyReadingzsixiang",
    component: () => import("@/components/earlyReading/zsixiang.vue"),
  },
  {
    path: "/sentence",
    name: "sentence",
    component: () => import("@/components/earlyReading/sentence.vue"),
  },
  {
    path: "/advancedReadingPracticeappleaa",
    name: "advancedReadingPracticeappleaa",
    component: () => import("@/components/advancedReadingPractice/appleaa.vue"),
  },
  {
    path: "/advancedReadingPrvideoappleaa",
    name: "advancedReadingPrvideoappleaa",
    component: () => import("@/components/advancedReadingPractice/videoappleaa.vue"),
  },
  //历史记录
  {
    path: "/HistoricalRecord",
    name: "HistoricalRecord",
    component: () => import("../components/HistoricalRecord.vue"),
  },

  {
    path: "/yingbiaoshibiezrpfla",
    name: "yingbiaoshibiezrpfla",
    component: () => import("@/components/youXi/yingbiaoshibie/zrpfla.vue"),
  },
  //首页
  {
    path: "/homeTools",
    name: "homeTools",
    component: () => import("../components/homtTools.vue"),
  },
  //个人页面
  {
    path: "/user",
    name: "user",
    component: () => import("../components/user_1.vue"),
  },
  {
    path: "/knowledgeListindex",
    name: "knowledgeListindex",
    component: () => import("@/components/knowledgeList/index.vue"),
  },
  //ai
  {
    path: "/Patrick",
    name: "Patrick",
    component: () => import("../components/A_1.vue"),
  },
  // //配音
  // {
  //   path:'/OralDubbing',
  //   name:'OralDubbing',
  //   component:()=>import('../components/OralDubbing/OralDubbing.vue')
  // },
  //批改作业
  {
    path: "/homework",
    name: "homework",
    component: () => import("../components/correcting/homework.vue"),
  },
  //魔法配图
  {
    path: "/Magic",
    name: "Magic",
    component: () => import("../components/picture/Magic.vue"),
  },

  //魔法图片主页
  {
    path: "/gszy",
    name: "gszy",
    component: () => import("../components/gszy_1.vue"),
  },
  //卡通合影
  {
    path: "/fwtzz",
    name: "/fwtzz",
    component: () => import("../components/fwtzz/Magic.vue"),
  },
  //魔法帖纸
  {
    path: "/Stickers",
    name: "Stickers",
    component: () => import("../components/Stickers/Magic.vue"),
  },
  //语音识别
  {
    path: "/Speech",
    name: "Speech",
    component: () => import("@/components/Speech/Speech0ne.vue"),
  },
  {
    path: "/thinkingmoban",
    name: "thinkingmoban",
    component: () => import("@/components/thinking/moban.vue"),
  },
  //支付
  {
    path: "/Payment",
    name: "Payment",
    component: () => import("../components/subAccountManagement/Payment.vue"),
  },
  //订单
  {
    path: "/Subscription",
    name: "Subscription",
    component: () => import("../components/Sub/Subscription.vue"),
  },
  //订单详情
  {
    path: "/details",
    name: "details",
    component: () => import("../components/Sub/details.vue"),
  },
  //订单结果
  {
    path: "/Result",
    name: "Result",
    component: () => import("../components/Sub/Result.vue"),
  },
  // //分享中心
  // {
  //   path:'/sharing',
  //   name:'sharing',
  //   component:()=>import('../components/Link/sharing.vue')
  // },
  //分享链接
  {
    path: "/Sharelink",
    name: "Sharelink",
    component: () => import("../components/Link/index.vue"),
  },
  {
    path: "/DedepdasSeek",
    name: "DedepdasSeek",
    component: () => import("@/components/mobilePhone/home/DeepSeek.vue"),
  },
  
  {
    path: "/realtime",
    name: "realtime",
    component: () => import("@/components/xz/realtime.vue"),
  },
  // //分享报告
  // {
  //   path:'/report',
  //   name:'report',
  //   component:()=>import('../components/Link/report.vue')
  // },
  //订单列表
  {
    path: "/OrderList",
    name: "OrderList",
    component: () => import("../components/Sub/OrderList.vue"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/homeTools",
    name: "homeTools",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/homtTools.vue"),
  },

  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/logo/logo.vue"),
  },

  {
    path: "/logo",
    name: "logo_1",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/logo_1.vue"),
  },
  {
    path: "/wxlogin",
    name: "wxlogin_1",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/wxlogin_1.vue"),
  },
  {
    path: "/ff",
    name: "ff",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/aI/ff.vue"),
  },
  {
    path: "/gpt",
    name: "gpt",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/gpt_t.vue"),
  },
  {
    path: "/work",
    name: "work",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/work_1.vue"),
  },
  {
    path: "/sc",
    name: "sc",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/aI/sc_1.vue"),
  },
  {
    path: "/HomeView",
    name: "HomeView",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/aI/HomeView.vue"),
  },
  //配音
  {
    path: "/OralDubbing",
    name: "OralDubbing",
    component: () => import("../components/OralDubbing/index.vue"),
  },
  //批改作业
  {
    path: "/homework",
    name: "homework",
    component: () => import("../components/correcting/homework.vue"),
  },
  //魔法配图
  {
    path: "/Magic",
    name: "Magic",
    component: () => import("../components/picture/Magic.vue"),
  },
  //魔法图片主页
  {
    path: "/gszy",
    name: "gszy",
    component: () => import("../components/gszy_1.vue"),
  },
  //单词扩展卡
  {
    path: "/buckledsfjsff",
    name: "buckledsfjsff",
    component: () => import("../components/buckle/dsfjsff.vue"),
  },
  {
    path: "/buckledsfjsffaa",
    name: "buckledsfjsffaa",
    component: () => import("../components/buckle/dsfjsffaa.vue"),
  },
    //卡通合影
  {
    path: "/fwtzz",
    name: "fwtzz",
    component: () => import("../components/fwtzz/Magic.vue"),
  },
  //魔法帖纸
  {
    path: "/Stickers",
    name: "Stickers",
    component: () => import("../components/Stickers/Magic.vue"),
  },
  //词汇表
  {
    path: "/WordList",
    name: "WordList",
    component: () => import("../components/WordList/Text.vue"),
  },
  //文本词汇表
  {
    path: "/Text",
    name: "Text",
    component: () => import("../components/WordList/Text.vue"),
  },
  //短语配音
  {
    path: "/dubbing",
    name: "dubbing",
    component: () => import("../components/OralDubbing/dubbing/dubbing.vue"),
  },
  //单词配音
  {
    path: "/OralDubbingdd",
    name: "OralDubbingdd",
    component: () => import("../components/OralDubbing/OralDubbing.vue"),
  },
  //自定义
  {
    path: "/custom",
    name: "custom",
    component: () => import("../components/OralDubbing/custom.vue"),
  },
  //发音分类评估
  {
    path: "/Pronunciation",
    name: "Pronunciation",
    component: () => import("@/components/Speech/index.vue"),
  },
  //聊天机器人
  {
    path: "/chat",
    name: "chat",
    component: () => import("@/components/chat/index.vue"),
  },
  //手机zf
  {
    path: "/Mobile",
    name: "Mobile",
    component: () => import("@/components/sjzf.vue"),
  },
  //svg
  {
    path: "/svg",
    name: "svg",
    component: () => import("@/components/svg.vue"),
  },
  //svg
  {
    path: "/svgcopy",
    name: "svgcopy",
    component: () => import("@/components/svgcopy.vue"),
  },
  //资源导航
  {
    path: "/Navigation",
    name: "Navigation",
    component: () => import("@/components/zy/index.vue"),
  },
  //文件上传
  {
    path: "/UploadFiles",
    name: "UploadFiles",
    component: () => import("@/components/UploadFiles/Uploadfiles.vue"),
  },
  //作业批改主页
  {
    path: "/petcorrectin",
    name: "petcorrectin",
    component: () => import("@/components/petcorrectin/home.vue"),
  },
  //pet作文批改
  {
    path: "/pettask",
    name: "pettask",
    component: () => import("@/components/petcorrectin/homework.vue"),
  },
  //电子文档归纳总结
  {
    path: "/electronic",
    name: "electronic",
    component: () => import("@/components/electronic/Uploadfiles.vue"),
  },
  //vip后台
  {
    path: "/vvvvvipht",
    name: "vvvvvipht",
    component: () => import("@/components/vvvvvipht/index.vue"),
  },
  //ppt生成器
  {
    path: "/pptcs",
    name: "pptcs",
    component: () => import("@/components/pptcs/index.vue"),
  },
  //ppt生成器结果
  {
    path: "/pptzjll",
    name: "pptzjll",
    component: () => import("@/components/pptcs/pptzjll.vue"),
  },
  //教程
  {
    path: "/video",
    name: "video",
    component: () => import("@/components/video/index.vue"),
  },

  //教程
  {
    path: "/study",
    name: "study",
    component: () => import("@/components/video/study.vue"),
  },
  //app充值
  {
    path: "/many",
    name: "many",
    component: () => import("@/components/app/many.vue"),
  },
  //教程
  {
    path: "/linking",
    name: "linking",
    component: () => import("@/components/OralDubbing/linking/index.vue"),
  },

  //手机
  {
    path: "/mobilePhone",
    name: "mobilePhone",
    component: () => import("@/components/mobilePhone/index.vue"),
  },

  //sk
  {
    path: "/flashCdard",
    name: "flashCdard",
    component: () => import("@/components/flashcard/flashcard.vue"),
  },
  //教程
  {
    path: "/PictureBooks",
    name: "PictureBooks",
    component: () => import("@/components/PictureBooks/PictureBooks.vue"),
  },

  //教程
  {
    path: "/language",
    name: "language",
    component: () => import("@/components/language/index.vue"),
  },
  //教程
  {
    path: "/languageddd",
    name: "languageddd",
    component: () => import("@/components/language/language.vue"),
  },
  {
    path: "/Management",
    name: "Management",
    component: () => import("@/components/Management/index.vue"),
  },
  
  {
    path: "/Homeworkee",
    name: "Homeworkee",
    component: () => import("@/components/Homeworkpaper/Homework.vue"),
  },
  {
    path: "/xiaoxiaole",
    name: "xiaoxiaole",
    component: () => import("@/components/youXi/xiaoxiaole/injdex.vue"),
  },
  {
    path: "/yingbiaoshibie",
    name: "yingbiaoshibie",
    component: () => import("@/components/youXi/yingbiaoshibie/index.vue"),
  },
  {
    path: "/zsixiang",
    name: "zsixiang",
    component: () => import("@/components/flashcard/zaixsk/zsixiang.vue"),
  },
  {
    path: "/jdfksgsg",
    name: "jdfksgsg",
    component: () => import("@/components/youXi/xiaoxiaole/jdfksgsg.vue"),
  },
  {
    path: "/dfghkldfg",
    name: "dfghkldfg",
    component: () => import("@/components/youXi/xiaoxiaole/dfghkldfg.vue"),
  },
  //手机首页
  {
    path: "/mobilePhonehome",
    name: "mobilePhonehome",
    component: () => import("@/components/mobilePhone/home/index.vue"),
    children: [
      // 手机首页
      {
        path: "homedd",
        name: "homedd",
        component: () => import("@/components/mobilePhone/home/home.vue"),
      },

      {
        path: "moeny",
        name: "moeny",
        component: () => import("@/components/mobilePhone/moeny/index.vue"),
      },
      {
        path: "my",
        name: "my",
        component: () => import("@/components/mobilePhone/my/index.vue"),
      },
      {
        path: "moeny1",
        name: "moeny1",
        component: () => import("@/components/mobilePhone/moeny/dsaadd.vue"),
      },
    ],
  },
  // 阅读精读
  {
    path: "/phraseExpansionReadinCcomprehension",
    name: "phraseExpansionReadinCcomprehension",
    component: () => import("@/components/phraseExpansion/ReadinCcomprehension/index.vue"),
  },
  // 读
  {
    path: "/phraseExpansionReadinCcomprehensionread",
    name: "phraseExpansionReadinCcomprehensionread",
    component: () => import("@/components/phraseExpansion/ReadinCcomprehension/read.vue"),
  },
  // 意
  {
    path: "/phraseExpansionReadinCcomprehensionanswer",
    name: "phraseExpansionReadinCcomprehensionanswer",
    component: () => import("@/components/phraseExpansion/ReadinCcomprehension/answer.vue"),
  },
  // 写
  {
    path: "/phraseExpansionReadinCcomprehensionhear",
    name: "phraseExpansionReadinCcomprehensionhear",
    component: () => import("@/components/phraseExpansion/ReadinCcomprehension/hear.vue"),
  },
    // 写_1
    {
      path: "/phraseExpansionReadinCcomprehensiohea_1",
      name: "phraseExpansionReadinCcomprehensiohea_1",
      component: () => import("@/components/phraseExpansion/ReadinCcomprehension/hea_1.vue"),
    },
  // 听
  {
    path: "/phraseExpansionReadinCcomprehensiokuanjia",
    name: "phraseExpansionReadinCcomprehensiokuanjia",
    component: () => import("@/components/phraseExpansion/ReadinCcomprehension/kuanjia.vue"),
  },

  // 对
  {
    path: "/phraseExpansionReadinCcomprehensiokumeaning",
    name: "phraseExpansionReadinCcomprehensiokumeaning",
    component: () => import("@/components/phraseExpansion/ReadinCcomprehension/meaning.vue"),
  },
  // 对1
  {
    path: "/phraseExpansionReadinCcomprehensiokumeani_1",
    name: "phraseExpansionReadinCcomprehensiokumeani_1",
    component: () => import("@/components/phraseExpansion/ReadinCcomprehension/meani_1.vue"),
  },
  {
    path: "/xuanfzf",
    name: "xuanfzf",
    component: () => import("@/components/aisijib/xuanfzf/xuanfzf.vue"),
  },





  {
    path: "/wordLearningwordLearning",
    name: "wordLearningwordLearning",
    component: () => import("@/NewCompnu/wordLearning/wordLearning.vue"),
  },







  {
    path: "/xzkasdhbz",
    name: "xzkasdhbz",
    component: () => import("@/components/xz/kasdhbz.vue"),
  },
  {
    path: "/indasjvb",
    name: "indasjvb",
    component: () => import("@/NewCompnu/yudulijie/indasjvb.vue"),
  },













  {
    path: "/work1",
    name: "work1",
    component: () =>
      import("@/components/mobilePhone/home/work/work1/homework.vue"),
  },
  {
    path: "/work3",
    name: "work3",
    component: () =>
      import("@/components/mobilePhone/home/work/workket/homework.vue"),
  },
  {
    path: "/work4",
    name: "work4",
    component: () => import("@/components/mobilePhone/home/fcehome/index.vue"),
  },
  {
    path: "/lsjl",
    name: "lsjl",
    component: () => import("@/components/mobilePhone/home/lsjl.vue"),
  },
  {
    path: "/spldajksvg",
    name: "spldajksvg",
    component: () => import("@/components/spldajk/svg.vue"),
  },
  {
    path: "/work1index",
    name: "work1index",
    component: () =>
      import("@/components/mobilePhone/home/work/work1/index.vue"),
  },
  {
    path: "/work2",
    name: "work2",
    component: () =>
      import("@/components/mobilePhone/home/work/work2/homework.vue"),
  },

  {
    path: "/aadds",
    name: "aadds",
    component: () => import("@/components/mobilePhone/home/chat/index.vue"),
  },
  {
    path: "/wordcatesd",
    name: "wordcatesd",
    component: () => import("@/components/WordCards/wordcates.vue"),
  },
 
  {
    path: "/dkana",
    name: "dkana",
    component: () => import("@/components/WordCards/dkana.vue"),
  },
  {
    path: "/wordIllustrationsXq",
    name: "wordIllustrationsXq",
    component: () => import("@/components/wordIllustrations/wordcates.vue"),
  },
  {
    path: "/artical",
    name: "artical",
    component: () => import("@/components/python/spider.vue"),
  },











  {
    path: "/fiveanwords",
    name: "fiveanwords",
    component: () => import("@/components/fiveanwords/fiveanwords.vue"),
  },
  // 快猜
  {
    path: "/QuickGuess",
    name: "QuickGuess",
    component: () => import("@/components/fiveanwords/fslkm/QuickGuess.vue"),
  },
  // 快选
  {
    path: "/QuickPick",
    name: "QuickPick",
    component: () => import("@/components/fiveanwords/fslkm/QuickPick.vue"),
  },
  // 快序
  {
    path: "/QuickSequence",
    name: "QuickSequence",
    component: () => import("@/components/fiveanwords/fslkm/QuickSequence.vue"),
  },
  // 快读
  {
    path: "/speedReading",
    name: "speedReading",
    component: () => import("@/components/fiveanwords/fslkm/speedReading.vue"),
  },
  // 快写
  {
    path: "/FastWrite",
    name: "FastWrite",
    component: () => import("@/components/fiveanwords/fslkm/FastWrite.vue"),
  },
  {
    path: "/haskdhaskdjbaskdhakdbakwdjwgqdbqbkjw",
    name: "haskdhaskdjbaskdhakdbakwdjwgqdbqbkjw",
    component: () => import("@/images/imgsiiudk.vue"),
  },












  {
    path: "/syllablemoban1",
    name: "syllablemoban1",
    component: () => import("@/NewCompnu/syllable/moban/moban1.vue"),
  },
  {
    path: "/syllablemoban2",
    name: "syllablemoban2",
    component: () => import("@/NewCompnu/syllable/moban/moban2.vue"),
  },
  {
    path: "/syllablemoban3",
    name: "syllablemoban3",
    component: () => import("@/NewCompnu/syllable/moban/moban3.vue"),
  },

  {
    path: "/NewCompnump3",
    name: "NewCompnump3",
    component: () => import("@/NewCompnu/mp3/index.vue"),
  },

 


  {
    path: "/UploadUpload",
    name: "UploadUpload",
    component: () => import("@/NewCompnu/Upload/Upload.vue"),
  },
  {
    path: "/InterlinkingInterlinking",
    name: "InterlinkingInterlinking",
    component: () => import("@/NewCompnu/Interlinking/Interlinking.vue"),
  },

  {
    path: "/xingypbfqypbfq",
    name: "xingypbfqypbfq",
    component: () => import("@/components/aisijib/xingypbfq/ypbfq.vue"),
  },

  {
    path: "/NewCompnuzhujuanzhujuan",
    name: "NewCompnuzhujuanzhujuan",
    component: () => import("@/NewCompnu/zhujuan/zhujuan.vue"),
  },

  {
    path: "/xiaoneiDCindex",
    name: "xiaoneiDCindex",
    component: () => import("@/components/aisijib/xiaoneiDC/index.vue"),
  },

  {
    path: "/glossaryglossary",
    name: "glossaryglossary",
    component: () => import("@/NewCompnu/glossary/glossary.vue"),
  },
  {
    path: "/ProfilePhotoMaker",
    name: "ProfilePhotoMaker",
    component: () => import("@/components/ProfilePhotoMaker/ProfilePhotoMaker.vue"),
  },
  {
    path: "/GenerateImages",
    name: "GenerateImages",
    component: () => import("@/components/GenerateImages/GenerateImages.vue"),
  },
  
       {
        path: "/EssayScaffolding1",
        name: "EssayScaffolding1",
        component: () => import("@/components/EssayScaffolding/index1.vue"),
      },
      {
        path: "/SuperSentenceMaker1",
        name: "SuperSentenceMaker1",
        component: () => import("@/components/SuperSentenceMaker/index1.vue"),
      },
  // 句子朗读详情页
      {
        path: "/detailsSentenceReading",
        name: "detailsSentenceReading",
        component: () => import("@/components/detailsSentenceReading/detailsSentenceReading.vue"),
      },
  {
    path: "/vipyouxivipxyoiuxi1",
    name: "vipyouxivipxyoiuxi1",
    component: () => import("@/NewCompnu/vipyouxi/vipxyoiuxi1.vue"),
  },
  {
    path: "/vipyouxivipxyoiuxi2",
    name: "vipyouxivipxyoiuxi2",
    component: () => import("@/NewCompnu/vipyouxi/vipxyoiuxi2.vue"),
  },
  {
    path: "/vipyouxivipxyoiuxi3",
    name: "vipyouxivipxyoiuxi3",
    component: () => import("@/NewCompnu/vipyouxi/vipxyoiuxi3.vue"),
  },
















  {
    path: "/reader",
    name: "reader",
    component: pyyy,
  },

  //  单词录入
  {
    path: "/rouet--v",
    name: "rouet--v",
    component: () => import("@/components/vvvvvipht/rouet/index.vue"),
    children: [
      {
        path: "dc",
        component: () => import("@/components/vvvvvipht/rouet/dc.vue"),
      },
      {
        path: "sk",
        component: () => import("@/components/vvvvvipht/rouet/sk.vue"),
      },
      {
        path: "DateComponent",
        component: () =>
          import("@/components/vvvvvipht/rouet/DateComponent.vue"),
      },
    ],
  },
   {
    path: '/:pathMatch(.*)*',
    redirect: '/' // 所有未匹配的路径都重定向到 /home
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
